import { submitCreateClient } from 'api/clients';
import { useMutation } from 'react-query';
import MoneyLenderSubmitBody from 'types/MoneyLenderSubmitBody';

export function useMutateCreateClient(
  onSuccess: (result: any) => void,
  onError: (error: any) => void
) {
  return useMutation((formData: MoneyLenderSubmitBody) => submitCreateClient(formData), {
    onSuccess,
    onError,
  });
}
